import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { isTouchDevice } from 'utils/detect-touch-device';

import { RateStar } from './Star';
import styles from './styles.pcss';
import LinkBlock from '../LinkBlock';

const cx = classNames.bind(styles);

/**
 * Five stars in a row, fills according to value
 * Component is stateless, disregarding preview state
 * given state only provides a viable way of viewing hovered value
 */
export default class FiveStarRate extends React.Component {
  /**
   * preview is a special fillValue, that overrides the normal value
   * it is used for hover effects, any falsy value resets preview
   */
  state = {
    preview: null,
  };

  getPreviewHandler = (index) => () => {
    const { onChange } = this.props;
    if (onChange) this.setState({ preview: index });
  };

  getChangeHandler = (index) => (e) => {
    const { onChange } = this.props;
    if (onChange) {
      e.preventDefault();
      onChange(index);
    }
  };

  getFillValue = (index) => (this.state.preview || this.props.value) - index + 1;

  getStarProps = (index) => ({
    isSmall: this.props.isCompact,
    onMouseEnter: isTouchDevice() ? null : this.getPreviewHandler(index),
    onClick: this.getChangeHandler(index),
    fillMeter: this.getFillValue(index),
  });

  render() {
    const { href, className, onChange } = this.props;
    const classes = cx('container', { interactive: !!onChange }, className);

    return (
      <LinkBlock
        className={classes}
        href={href}
        onMouseLeave={isTouchDevice() ? null : this.getPreviewHandler(0)}
      >
        <RateStar {...this.getStarProps(1)} />
        <RateStar {...this.getStarProps(2)} />
        <RateStar {...this.getStarProps(3)} />
        <RateStar {...this.getStarProps(4)} />
        <RateStar {...this.getStarProps(5)} />
      </LinkBlock>
    );
  }
}

FiveStarRate.propTypes = {
  value: PropTypes.number, // floating number from 0 to 5, representing rating
  href: PropTypes.string,
  isCompact: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
};
